import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { BackupLenderTemplate } from '~/backup/lender/domains/page/ui/BackupLenderTemplate';
import { PortfolioView } from '~/backup/lender/views/portfolio/PortfolioView';
import { StratsView } from '~/backup/lender/views/strats/StratsView';
import { AgentView } from '~/backup/shared/views/agent/AgentView';
import { BackupDataPipelineRoutes } from '~/backup/shared/views/data-pipeline/DataPipelineRoutes';
import { DealOverviewView } from '~/backup/shared/views/deal-overview/DealOverviewView';
import { DealSettingsHub } from '~/backup/shared/views/deal-settings/DealSettingsHub';
import { CycleRedirect } from '~/backup/shared/views/deliverables/CycleRedirect';
import { DealFilesRedirect } from '~/backup/shared/views/deliverables/DealFilesRedirect';
import { DeliverablesView } from '~/backup/shared/views/deliverables/DeliverablesView';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { DefaultErrorRoute } from '~/core/DefaultErrorRoute';

export const BackupLenderRouter = (): React.ReactElement => {
  return (
    <BackupLenderTemplate>
      <Routes>
        <Route
          path="/portfolio"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <PortfolioView />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/strats"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <StratsView />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/deals/:implementationId"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <DealOverviewView />
            </RouteErrorBoundary>
          }
        />
        {/* A period renders the same Overview, scoped to that period. */}
        <Route
          path="/deals/:implementationId/periods/:reportingPeriod"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <DealOverviewView />
            </RouteErrorBoundary>
          }
        />
        <Route
          path="/deals/:implementationId/deliverables"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <DeliverablesView />
            </RouteErrorBoundary>
          }
        />
        {/* Legacy paths, kept so existing links / bookmarks still land. */}
        <Route
          path="/deals/:implementationId/cycles/:cycleId"
          element={<CycleRedirect />}
        />
        <Route
          path="/deals/:implementationId/files"
          element={<DealFilesRedirect />}
        />
        <Route
          path="/deals/:implementationId/settings/*"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <DealSettingsHub />
            </RouteErrorBoundary>
          }
        />
        <Route path="/data-pipeline/*" element={<BackupDataPipelineRoutes />} />
        <Route
          path="/agent"
          element={
            <RouteErrorBoundary
              resetAfterCatch={false}
              fallback={({ message, showErrorToast }) => {
                showErrorToast(message);
                return <DefaultErrorRoute />;
              }}
            >
              <AgentView />
            </RouteErrorBoundary>
          }
        />
        <Route path="/" element={<Navigate to="/portfolio" replace />} />
        <Route path="/*" element={<Navigate to="/portfolio" replace />} />
      </Routes>
    </BackupLenderTemplate>
  );
};
